class LineManagerController {
    constructor() {        
    }

    showLineManager() {
        if (this.readonly && this.hasAlternativeOfficer) {
            return false;
        }
        return true;
    }
}

LineManagerController.$inject = ['_', 'componentRegistryService'];

export default {
controller: LineManagerController,
bindings: {
    modelName:'@',
    readonly: '<',
    lineManagers: '<',
    primaryLineManager: '<',
    hasAlternativeOfficer: '<',
    isForeignInterferenceDisclosure: '<',
    onUserValidate: '&'
},
templateUrl:`app/disclose/conflictOfInterest/components/line-alternative-manager/line-alternative-manager.html`
};



// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/components/line-alternative-manager/line-alternative-manager.component.js